// TelcoTrack — mark a filter toolbar to sit on the page-header subtitle row.

import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { PageHeaderFiltersService } from '../../core/services/page-header-filters.service';

@Directive({
  selector: '[ttPageHeaderFilters]',
})
export class PageHeaderFiltersDirective implements AfterViewInit, OnDestroy {
  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly filtersSlot: PageHeaderFiltersService,
  ) {}

  ngAfterViewInit(): void {
    this.filtersSlot.attach(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.filtersSlot.detach(this.host.nativeElement);
  }
}
